export default "__VITE_ASSET__CKKWZGCD__"